import { useContext } from 'react';

import SchemaDetailContext from '@atom/components/schemaDetail/SchemaDetailContext';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import AttributeDetail from './attributeDetail/AttributeDetail';
import AttributeGroupDetail from './attributeGroupDetail/AttributeGroupDetail';
import SubItemDetail from './subItemDetail/SubItemDetail';
import SubItemTree from './subItemTree/SubItemTree';

import classes from './schemaBuilder.module.css';

const SchemaBuilder = () => {
  const { selectedSubItem, selectedAttribute, selectedAttributeGroup } =
    useContext(SchemaDetailContext);

  const showSubItemDetail = !isNilOrEmpty(selectedSubItem);
  const showAttributeDetail =
    !isNilOrEmpty(selectedSubItem) && !isNilOrEmpty(selectedAttribute);
  const showAttributeGroupDetail =
    !isNilOrEmpty(selectedSubItem) && !isNilOrEmpty(selectedAttributeGroup);

  return (
    <>
      <div className={classes.builderColumn}>
        <SubItemTree />
      </div>
      {showSubItemDetail && (
        <div className={classes.builderColumn}>
          <SubItemDetail />
        </div>
      )}
      {showAttributeDetail && (
        <div className={classes.builderColumn}>
          <AttributeDetail />
        </div>
      )}
      {showAttributeGroupDetail && (
        <div className={classes.builderColumn}>
          <AttributeGroupDetail />
        </div>
      )}
    </>
  );
};

export default SchemaBuilder;
